import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Business Consulting - Elm Street</title>
        <meta name="description" content="Build your brand with a little help from our experts." />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/business_consulting" />
        <meta property="og:title" content="Business Consulting - Elm Street" />
        <meta property="og:description" content="Build your brand with a little help from our experts." />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <div
        style={{
          backgroundImage: "url('businessbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Business Consulting"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    business
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>consulting</span>
                  </Typography>
                  <p>Build your brand...with a little help.</p>

                  <Button variant="contained" color="secondary" href="#form">
                    Schedule Consultation
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ marginTop: "45px", marginBottom: "88px" }}>
        <div
          style={{
            paddingTop: "55px",
            paddingBottom: "55px",
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h4">
            <span style={{ color: "#f69c26" }}>areas of</span> expertise
          </Typography>
          Elm Street's elite 3sixtyfive.agency division is a creative &amp; digital marketing consultancy focused on
          business growth strategies for brokers, teams and agents. We specialize in agent recruitment and retention,
          mergers and acquisitions, business identity, and market expansion through the creation and execution of unique
          marketing experiences that connect
          <br />
          people &amp; brands together.
        </div>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={4} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/brand_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street Business Consulting - Brand Expansion"
              />
            </div>
            <strong>
              BRAND
              <br />
              EXPANSION
            </strong>
          </Grid>
          <Grid item md={4} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/retention_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street Business Consulting - Recruitment &amp; Retention"
              />
            </div>
            <strong>
              RECRUITMENT
              <br />
              &amp; RETENTION
            </strong>
          </Grid>
          <Grid item md={4} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/coaching_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street Business Consulting - Business &amp; Recruitment Coaching"
              />
            </div>
            <strong>
              BUSINESS &amp;
              <br />
              RECRUITMENT COACHING
            </strong>
          </Grid>
        </Grid>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={4} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/creative_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street Business Consulting - Creative Consulting"
              />
            </div>
            <strong>
              CREATIVE
              <br />
              CONSULTING
            </strong>
          </Grid>
          <Grid item md={4} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/identity_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street Business Consulting - Brand Identity"
              />
            </div>
            <strong>
              BRAND
              <br />
              IDENTITY
            </strong>
          </Grid>
          <Grid item md={4} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image
                src="/analytics_icon.svg"
                width="100px"
                height="100px"
                alt="Elm Street Business Consulting - Execution &amp; Analysis"
              />
            </div>
            <strong>
              EXECUTION
              <br />
              &amp; ANALYSIS
            </strong>
          </Grid>
          <Grid item md={3} sm={12}></Grid>
        </Grid>
      </Container>

      <div
        style={{
          backgroundImage: "url('horizonbg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "105px", paddingBottom: "40px", marginTop: "55px" }}>
          <Grid container columnSpacing={8} style={{ paddingBottom: "45px;" }}>
            <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
              <Headshot
                src="/headshots/mpappas.jpg"
                name=""
                title=""
                alt="Mike Pappas - President &amp; CEO of The Keyes Company"
              />
            </Grid>
            <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
                mike pappas
              </Typography>
              <strong style={{ color: "#ffffff" }}>
                President &amp; CEO
                <br />
                The Keyes Company
                <br />
              </strong>
              <br />
              <span style={{ color: "#ffffff" }}>
                “In an industry that has become very tech driven, we constantly remind ourselves that this business is
                about relationships and showing the value you bring. 3sixtyfive.agency has helped us leverage technology
                in unique ways while maintaining a people-centric focus on fostering relationships. The secret is in the
                balance between the two.”
                <br />
                <br />
                Read how we work with The Keyes Company to expand their business...
                <br />
                <div style={{ paddingTop: "10px" }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    href="/blog/becoming-the-broker-of-choice"
                    target="_blank"
                  >
                    read full article
                  </Button>
                </div>
              </span>
            </Grid>
          </Grid>

          <Grid container columnSpacing={8} style={{ paddingBottom: "45px;" }}>
            <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
              <Headshot
                src="/headshots/kmaus.jpg"
                name=""
                title=""
                alt="Katie Maus - Agent Liason for Carolina One Real Estate"
              />
            </Grid>
            <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
                katie maus
              </Typography>
              <strong style={{ color: "#ffffff" }}>
                Agent Liason
                <br />
                Carolina One Real Estate
                <br />
                <br />
              </strong>
              <span style={{ color: "#ffffff" }}>
                “As a large real estate brokerage, we have an internal marketing department, but their highest priority
                is to assist our agents with the promotion of their listings, sales, and services. We needed a marketing
                team to create collateral showing how we support our agents, and what tools and programs we offer to
                assist in their success.
                <br />
                <br />
                3sixtyfive.agency took the time to truly learn and understand our company and our value proposition and
                turned that into messaging to current and prospective agents that looked professional, and looked as if
                it were coming directly from us. They are easy to work with and we are extremely happy with our
                partnership thus far. We have yielded multiple hires in the first 6 months that can be attributed to
                their services."
              </span>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ marginTop: "85px", marginBottom: "68px", paddingTop: "20px" }}>
        <div
          style={{
            paddingTop: "25px",
            paddingBottom: "55px",
            textAlign: "center",
          }}
        >
          <Typography variant="h4" component="h4">
            <span style={{ color: "#f69c26" }}>happy</span> clients
          </Typography>
        </div>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px", paddingTop: "20px" }}>
              <Image src="/keyes.png" width="800px" height="348px" alt="The Keyes Company" />
            </div>
          </Grid>

          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/cs.png" width="600px" height="510px" alt="Christian Shane" />
            </div>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/at.png" width="120px" height="120px" alt="Allan &amp; Tate" />
            </div>
          </Grid>

          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/bw.jpg" width="120px" height="120px" alt="Baird &amp; Warner" />
            </div>
          </Grid>
        </Grid>

        <Grid container columnSpacing={16} style={{ textAlign: "center" }}>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/pg.png" width="800px" height="210px" alt="The Platinum Group" />
            </div>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/co.png" width="300px" height="191px" alt="Carolina One Real Estate" />
            </div>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/c21.png" width="95px" height="121px" alt="Century 21" />
            </div>
          </Grid>
          <Grid item md={3} sm={12} style={{ paddingBottom: "33px" }}>
            <div style={{ paddingBottom: "13px" }}>
              <Image src="/remax.png" width="450px" height="85px" alt="RE/MAX" />
            </div>
          </Grid>
        </Grid>
      </Container>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{ textAlign: "center" }}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746" }}>
              schedule consultation
            </Typography>
            <div style={{ paddingBottom: "40px" }}>
              <strong style={{ color: "#1d1746" }}>Connect with our team to explore your unique needs.</strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      successUrl="thankyou-3sixtyfive"
                      listId="147991"
                      formName="es2_business_consulting"
                      fieldList={["first_name", "last_name", "email", "phone", "roll", "accomplish"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
